export default __webpack_public_path__ + "static/media/ney_york.0c7358bc.jpg";